import React from 'react'
import { connect } from 'react-redux'
import { FeatureTooltip } from '@driftt/tide-tooltips-legacy'
import { updateUserProperties } from 'app/modules/user/properties/actions'
import * as UserSelectors from 'app/modules/user/selectors'
import * as UserPropertiesSelectors from 'app/modules/user/properties/selectors'

const USER_PROPERTY_KEY = 'hasDismissedTeamStatusTooltip'

const TeamAvailabilityStatusTooltip = ({ showTooltip, updateUserProperties }) => (
    <div className="team-availability-status-tooltip-container">
        <FeatureTooltip
            className="team-online-status-feature-tooltip"
            headerCopy="See at a glance when your team is online or offline"
            bodyCopy="Based on a team's scheduled hours and teammate availability, we'll let you know whether that team is currently online or offline."
            ribbonType="new"
            showTooltip={showTooltip}
            tooltipSide="top"
            tooltipCaretLocation="center"
            onClose={updateUserProperties}
        />
    </div>
)

const mapStateToProps = state => {
  const userProperties = UserPropertiesSelectors.properties(state)
  const currentUser = UserSelectors.currentUser(state)
  const wasUserCreatedBeforeIntroduction = currentUser.createdAt < 1569004688000 // new Date('2019-08-18').getTime()
  return {
    showTooltip: wasUserCreatedBeforeIntroduction && !userProperties.get(USER_PROPERTY_KEY)
  }
}

const mapDispatchToProps = dispatch => ({
  updateUserProperties: () => dispatch(updateUserProperties({
    notify: false,
    properties: {
      [USER_PROPERTY_KEY]: true,
    },
  }))
})

export default connect(mapStateToProps, mapDispatchToProps)(TeamAvailabilityStatusTooltip)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Teams/TeamsList/TeamAvailabilityStatusTooltip/index.js